import { render, staticRenderFns } from "./VModalWorkLogs.vue?vue&type=template&id=5a6c740f&"
import script from "./VModalWorkLogs.vue?vue&type=script&lang=js&"
export * from "./VModalWorkLogs.vue?vue&type=script&lang=js&"
import style0 from "./VModalWorkLogs.vue?vue&type=style&index=0&id=5a6c740f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports